// extracted by mini-css-extract-plugin
export default {"badge":"DoctorSpecialization_badge__hrPYY","button":"DoctorSpecialization_button__NdV9-","xMark":"DoctorSpecialization_xMark__KUv30"};